import "./scss/app.scss";

import Vue from 'vue';
import { InlineSvgPlugin } from 'vue-inline-svg';

Vue.config.productionTip = false
Vue.use(InlineSvgPlugin);

import 'element-closest-polyfill';
import GuardImage from './tools/guardImage'

new Vue({
  components: {
    ExhibitionDiamond: () => import('./components/ExhibitionDiamond.vue'),
    ExhibitionMoney: () => import('./components/ExhibitionMoney.vue'),
    ExhibitionBank: () => import('./components/ExhibitionBank.vue'),
  },
  data() {
    return {
      GuardImageInstance: null
    }
  },
  mounted() {
    this.GuardImageInstance = new GuardImage()
  },
  beforeDestroy() {
    this.GuardImageInstance?.destroy()
  },
  methods: {
  }
}).$mount('#app')
